export default {
  'setVariable.title': 'Establecer Variables',

  'setVariable.form.sourceForm': 'Formulario Origen',
  'setVariable.form.sourceField': 'Campo Origen',
  'setVariable.form.formFieldValueSource': 'Origen Valor Campo',
  'setVariable.form.variable': 'Variable',

  'setVariable.form.valueSource': 'Origen Valor',
  'setVariable.form.sourceVariable': 'Variable Origen',
  'setVariable.form.form': 'Formulario',
  'setVariable.form.field': 'Campo',
  'setVariable.form.formula': 'Formula',
  'setVariable.form.fixedValue': 'Valor Fijo',
  'setVariable.form.internalField': 'Campo Interno',

  'setVariable.form.parameterValueFilterComparisonOperator': 'Operador para Filtro',
  'setVariable.form.parameterValueFilter': 'Valor Filtro Parámetro',

  'setVariable.form.formFieldValueDestination': 'Destino Valor Campo',

  'setVariable.form.tableParameterName': 'Nombre Parámetro Lista',
  'setVariable.form.parameterName': 'Nombre Parámetro',
  'setVariable.form.attachmentFileName': 'Nombre del Adjunto',
  'setVariable.form.attachmentContentType': 'Tipo de Contenido',

  'setVariable.form.select.FormField': 'Formulario / Campo',
  'setVariable.form.select.Variable': 'Variable',

  'setVariable.form.select.Formula': 'Formula',
  'setVariable.form.select.FixedValue': 'Valor Fijo',
  'setVariable.form.select.InternalField': 'Campo Interno',
  'setVariable.form.select.IterationStepData': 'Iteración / Datos',
  'setVariable.form.select.GeneratedDocument': 'Documento Generado',

  'setVariable.form.select.FieldValue': 'Valor a Mostrar',
  'setVariable.form.select.FieldSearchValue': 'Valor de Búsqueda',
};
